import { useSelectedProductFamilyNames } from '../../../selectors';
import { ProductFamilyListing } from './product-family-listing';
import { containerStyle } from './product-summary.styles';

const ProductSummary = () => {
  const [selectedProductFamilyNames] = useSelectedProductFamilyNames();

  return (
    <div css={containerStyle} data-testid="product-summary">
      {selectedProductFamilyNames.map((productFamilyName) => (
        <ProductFamilyListing
          key={productFamilyName}
          productFamilyName={productFamilyName}
        />
      ))}
    </div>
  );
};

export { ProductSummary };
